export * from './navbar.module';
export * from './navbar.component';



// WEBPACK FOOTER //
// C:/Users/bompadre/Documents/angular2/myapp2/node_modules/angular-bootstrap-md/navbars/index.ts